<template>
    <div class="wrapper" :class="{show:!isLoading}">
        <side-bar></side-bar>

        <div class="main-panel">
            <nav-bar></nav-bar>

            <transition name="fade-wrapper">
                <router-view class="content">
                </router-view>
            </transition>

            <footer-bar></footer-bar>
        </div>
    </div>
</template>
<script>
    import SideBar from '@/components/includes/SideBar';
    import NavBar from '@/components/includes/NavBar';
    import FooterBar from '@/components/includes/FooterBar';
    import JwtService from '@/services/jwt.service';

    export default {
        props: ["title", "isLoading"],
        data() {
            return {
                show: false
            };
        },
        methods: {
            toggle() {
                if (this.show) {
                    document.getElementsByTagName("html")[0].classList.add('nav-open');
                    document.getElementById("toggle-navigation").classList.add('toggled');
                    document.body.classList.add('sidebar-mini');
                } else {
                    document.getElementsByTagName("html")[0].classList.remove('nav-open');
                    document.getElementById("toggle-navigation").classList.remove('toggled');
                    document.body.classList.remove('sidebar-mini');
                }
                this.show = !this.show;
            }
        },
        components: {
            "side-bar": SideBar,
            "nav-bar": NavBar,
            "footer-bar": FooterBar
        }
    };
</script>

<style scoped>
    .main-panel{
        background: #DDD !important;
    }

    .main-panel>.content{
        padding-bottom: 100px !important;
    }

    @media (min-width: 1024px){
        .footer {
            left: 0;
        }
    }
</style>
